import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
    selector: 'app-annule-cmd-negoce',
    templateUrl: './annule-cmd-negoce.component.html',
    styleUrls: ['./annule-cmd-negoce.component.scss']
})
export class AnnuleCmdNegoceComponent implements OnInit {
    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('AnnuleCmdNegoceComponent initialized');
        this.dataService.filterOrdersByStatus('Annulé');
    }
}
